import React, { useEffect, useState } from 'react';
import VendorNavbar from '../../common/layout/VendorNavbar';
import { Link, useLocation } from 'react-router-dom';
import { useSocket } from '../../Contexts/SocketContext';
import { FaRegBell } from 'react-icons/fa';

const VendorLoginLayout = ({ children }: any) => {
  const { socketInstance } = useSocket();
  const location = useLocation();

  const [hasNotifications, setHasNotifications] = useState([]);
  useEffect(() => {
    if (socketInstance) {
      setTimeout(() => {
        socketInstance.emit('getNotifications');
      }, 300);
      socketInstance.on('notifications', (notifications: any) => {
        const mappedunreadNotifications = notifications.filter(
          (notification: any) => !notification.read
        );
        setHasNotifications(mappedunreadNotifications);
      });

      socketInstance.on('updateNotifications', (notification: any) => {
        socketInstance.emit('getNotifications');
      });

      return () => { };
    }
  }, [socketInstance]);

  const bellAndSettingsIcon = (
    <div className="flex space-x-4 text-white">
      <div className="relative mx-2 lg:mx-0">
        <Link to="/vendor-login/vendor-notification">
          <FaRegBell
            className={`w-[20px] h-[20px]  ${location.pathname.startsWith('/vendor-login/vendor-notification') ? 'text-[#006BEA]' : 'text-white'}`}
          />
          {hasNotifications.length > 0 && (
            <span
              className={`absolute top-[-5px] ${hasNotifications.length < 99 ? 'right-0 left-2 bottom-5' : 'right-0'} inline-flex items-center justify-center
            ${hasNotifications.length < 99 ? 'w-4 h-4 p-[2px]' : 'w-[18px] h-[18px] px-[2px]'} 
            ${hasNotifications.length < 99 ? 'text-[9px]' : 'text-[8px]'} 
            bg-red-500 text-white font-semibold rounded-full`}
            >
              {hasNotifications.length > 99 ? '99+' : hasNotifications.length}
            </span>
          )}
        </Link>


      </div>
    </div>
  );
  return <VendorNavbar bellAndSettingsIcon={bellAndSettingsIcon} children={children} />;
};

export default VendorLoginLayout;
